<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>
              {{ source.title }}
              <open-on-site
                :source-route="'staff#' + source.id"
              />
            </h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <ckeditor id="Description" v-model="entity.description" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Thumbnail</label>
                  <div class="col-md-10">
                    <image-uploader
                      :uploaded-img-url="avatarUrl"
                      @changeFile="changeAvatar"
                      @returnedOldFile="avatarRestore"
                      @existingFileRemoved="avatarRemove"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="saveEntity">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">Data saved successful!</div>
          <div class="alert alert-danger" style="display: none;">{{ saveErrorMessage }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';

export default {
  name: 'StaffEdit',
  components: {
    'open-on-site': OpenOnSiteButton,
  },
  mixins: [EditPageMixin],
  data() {
    return {
      source: null,
      entity: {},
    };
  },

  computed: {
    avatarUrl() {
      if (!this.source) return null;
      if (Object.prototype.hasOwnProperty.call(this.source, 'avatar') && this.source.avatar) {
        return this.source.avatar.public_url;
      }
      return null;
    },
    avatarIsChanged() {
      if (!this.source.avatar) {
        return !!this.entity.avatar;
      }
      if (_.isObject(this.entity.avatar) && this.entity.avatar.id === this.source.avatar.id) {
        return false;
      }
      return true;
    },
  },

  methods: {
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}staff/${this.$route.params.id}?with[]=avatar&with[]=path_alias`)
        .then((response) => {
          this.source = response.data;
          this.entity = _.cloneDeep(response.data);
          if (!Object.prototype.hasOwnProperty.call(response.data, 'path_alias')) {
            this.source.path_alias = {
              path_alias: '',
            };
            this.entity.path_alias = {
              path_alias: '',
            };
          }
          if (!Object.prototype.hasOwnProperty.call(response.data, 'avatar')) {
            this.source.avatar = null;
            this.entity.avatar = null;
          }
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        })
        .catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting data request' });
          console.error(error);
        });
    },
    isEntityValid() {
      const validPathRegEx = new RegExp('[^A-Za-z0-9_-]');
      if (!this.entity.title) {
        this.$_showError('Title field is required');
        return false;
      }
      if (this.entity.path_alias.path_alias.match(validPathRegEx)) {
        this.$_showError('Path Alias should content only letters, digits and symbols -, _');
        return false;
      }
      return true;
    },
    changeAvatar(file) {
      this.entity.avatar = file;
    },
    avatarRestore() {
      this.entity.avatar = this.source.avatar;
    },
    avatarRemove() {
      this.entity.avatar = null;
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('description', this.entity.description ? this.entity.description : '');
      postFormData.append('path_alias', this.entity.path_alias.path_alias);
      postFormData.append('seo_title', this.entity.seo_title);
      postFormData.append('seo_description', this.entity.seo_description);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}staff/${this.$route.params.id}`, postFormData);
    },
    saveAvatarRequest() {
      const postFormData = new FormData();
      postFormData.append('avatar', this.entity.avatar);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}staff/${this.$route.params.id}/avatar`, postFormData);
    },
    deleteAvatarRequest() {
      return this.$apiHttp.delete(`${this.$config.app_api.prefix}staff/${this.$route.params.id}/avatar`);
    },
    saveEntity() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      if (!this.avatarIsChanged) {
        this.saveRequest().then(() => {
          this.$_successSave();
        }).catch((error) => {
          this.$_errorSave(error);
          console.error('Error in update staff query', error);
        });
      } else if (!this.entity.avatar) {
        axios.all([this.deleteAvatarRequest(), this.saveRequest()]).then(axios.spread((avatar, entity) => {
          if (Math.round(avatar.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            this.$_successSave();
          } else {
            this.$_showError('Error in data saving');
          }
        }));
      } else {
        axios.all([this.saveAvatarRequest(), this.saveRequest()]).then(axios.spread((avatar, entity) => {
          if (Math.round(avatar.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            this.$_successSave();
          } else {
            this.$_showError('Error in data saving');
          }
        }));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?3ac25267